module.exports = __webpack_public_path__ + "static/media/page-shoppingNotes.6fd16dba.jpg";